var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
import * as React from 'react';
import styled from 'styled-components';
import { Button } from '../../../Button';
import { color, spacing, typography, fontWeight } from '../../../../constants';
var Container = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-top: ", ";\n"], ["\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-top: ", ";\n"])), spacing.extraTight);
var RecentSearch = styled(Button)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  margin-right: 2px;\n  padding: 0;\n  color: ", ";\n  font-size: inherit;\n  font-weight: inherit;\n  height: auto;\n\n  > span {\n    display: inline-block;\n    white-space: nowrap;\n    max-width: 100px;\n    overflow: hidden;\n    text-overflow: ellipsis;\n  }\n\n  &::after {\n    content: ',';\n  }\n\n  &:last-of-type::after {\n    content: '';\n  }\n\n  &:hover {\n    border-color: transparent;\n    text-decoration: underline;\n  }\n"], ["\n  margin-right: 2px;\n  padding: 0;\n  color: ", ";\n  font-size: inherit;\n  font-weight: inherit;\n  height: auto;\n\n  > span {\n    display: inline-block;\n    white-space: nowrap;\n    max-width: 100px;\n    overflow: hidden;\n    text-overflow: ellipsis;\n  }\n\n  &::after {\n    content: ',';\n  }\n\n  &:last-of-type::after {\n    content: '';\n  }\n\n  &:hover {\n    border-color: transparent;\n    text-decoration: underline;\n  }\n"])), color.theme.primaryColor.action.primary);
var ToolText = styled.p.attrs({
    'data-testid': 'SearchTools-toolText'
})(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  display: inline-block;\n  color: ", ";\n  ", "\n\n  strong {\n    font-weight: ", ";\n  }\n"], ["\n  display: inline-block;\n  color: ", ";\n  ", "\n\n  strong {\n    font-weight: ", ";\n  }\n"])), color.theme.typography.subdued, typography.inputHelp, fontWeight.bold);
function reorderRecent(qHistory) {
    return __spreadArray([], qHistory).reverse();
}
var CurrentSearchText = function (props) {
    /* eslint-disable-next-line */
    if (props.active === '' && !props.noResults)
        return null;
    /* eslint-disable-next-line */
    if (props.active !== '' && props.noResults) {
        return (React.createElement(ToolText, null,
            "Search returned ",
            React.createElement("strong", null, "0"),
            " results"));
    }
    return (React.createElement(ToolText, null,
        "Search term: ",
        React.createElement("strong", null, props.active)));
};
var SearchTools = function (_a) {
    var active = _a.active, recent = _a.recent, noResults = _a.noResults, onRecentClick = _a.onRecentClick;
    var recentSearches = reorderRecent(recent);
    return (React.createElement(Container, null,
        React.createElement(CurrentSearchText, { active: active, noResults: noResults }),
        recentSearches.length > 0 ? (React.createElement(ToolText, null,
            "(Recent:",
            ' ',
            recentSearches.map(function (search, i) { return (React.createElement(RecentSearch, { "data-testid": "SearchTools-recentSearch", key: i + "-" + search, appearance: "plain", onClick: onRecentClick(search) }, search)); }),
            ")")) : null));
};
export { SearchTools };
var templateObject_1, templateObject_2, templateObject_3;
//# sourceMappingURL=SearchTools.js.map